webpackJsonp([1],{

/***/ "EzZF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//


/* harmony default export */ var App = ({
  name: 'app',
  created: function created() {
    console.log('App created');
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c67e003","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("EzZF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Home.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Home = ({
  name: 'Home',
  filters: {
    twoSentences: function twoSentences(text) {
      var tmp = text.replace('a.k.a.', 'AKA').split('. ', 3);
      tmp.pop();
      return tmp.join('. ') + '.';
    }
  },
  metaInfo: function metaInfo() {
    return {
      title: this.title,
      meta: [{ vmid: 'description', name: 'description', content: this.description }]
    };
  },
  data: function data() {
    return {
      title: 'Reactive SEO experiment with Vue.js (rendered title)',
      description: 'is is a reactive SEO experiment to test Search Engine\'s indexing capabilities with front-end Javascript frameworks, in this case Vue.js (rendered description)',
      delay: 300,
      msg: 'Text below the above line is rendered by Vue.js reactively, but is rendered immediately, without REST calls. Here\'s a description of the novel:',
      msg2: 'Text below the following line is rendered by Vue.js reactively, and is shown after a delay of 300 ms',
      msg3: 'Text below the following line is rendered by Vue.js reactively, and comes from a REST service. Each character bio comes from a separate web service call, and each is delayed by a number of milliseconds. The delay of each REST call is detailed after  each text.',
      text1: 'Infinite Jest',
      text2: 'Infinite Jest (1996) is a novel written by David Foster Wallace. The lengthy and complex work takes place in a semi-parodic future version of North America. The novel touches on the topics of tennis; substance addiction and recovery programs; depression; child abuse; family relationships; advertising and popular entertainment; film theory; and Quebec separatism.',
      text3: 'The novel derives its name in part from a line in Hamlet, in which Hamlet refers to the skull of Yorick, the court jester: "Alas, poor Yorick! I knew him, Horatio: a fellow of infinite jest, of most excellent fancy: he hath borne me on his back a thousand times; and now, how abhorred in my imagination it is!"',
      delayedText: '',
      errors: [],
      services: [{
        name: 'James',
        url: '/james',
        delay: 0
      }, {
        name: 'Avril',
        url: '/avril',
        delay: 300
      }, {
        name: 'Hal',
        url: '/hal',
        delay: 600
      }, {
        name: 'Mario',
        url: '/mario',
        delay: 900
      }, {
        name: 'Orin',
        url: '/orin',
        delay: 1200
      }, {
        name: 'Pemulis',
        url: '/pemulis',
        delay: 1500
      }, {
        name: 'Stice',
        url: '/stice',
        delay: 1800
      }, {
        name: 'Wayne',
        url: '/wayne',
        delay: 2100
      }, {
        name: 'Gately',
        url: '/gately',
        delay: 2400
      }, {
        name: 'Joelle',
        url: '/joelle',
        delay: 2700
      }],
      posts: []
    };
  },

  methods: {
    addDelayedText: function addDelayedText() {
      this.delayedText = this.text3;
    }
  },
  created: function created() {
    var _this = this;

    console.log('Home created');

    var _loop = function _loop(service) {
      console.log(service);
      axios_default.a.get('https://hcetest.getsandbox.com' + _this.services[service].url).then(function (response) {
        // JSON responses are automatically parsed.
        console.log(response.data);
        _this.posts.push({
          title: _this.services[service].name,
          delay: _this.services[service].delay,
          data: response.data.status
        });
        // console.log(this.posts)
      }).catch(function (e) {
        _this.errors.push(e);
      });
    };

    for (var service in this.services) {
      _loop(service);
    }
    window.setTimeout(this.addDelayedText, this.delay);

    // async / await version (created() becomes async created())
    //
    // try {
    //   const response = await axios.get(`http://jsonplaceholder.typicode.com/posts`)
    //   this.posts = response.data
    // } catch (e) {
    //   this.errors.push(e)
    // }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-286722ba","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
var Home_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('p',[_c('em',[_vm._v(_vm._s(_vm.msg))])]),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.text1))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.text2))]),_vm._v(" "),_c('p',[_c('em',[_vm._v(_vm._s(_vm.msg2))])]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.delayedText.length > 0)?_c('p',[_vm._v(_vm._s(_vm.delayedText))]):_vm._e(),_vm._v(" "),_c('p',[_c('em',[_vm._v(_vm._s(_vm.msg3))])]),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._l((_vm.posts),function(post){return _c('div',[_c('h2',[_vm._v(_vm._s(post.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm._f("twoSentences")(post.data)))]),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'character', params: { name: post.title } }}},[_vm._v(">See full bio")]),_vm._v(" "),_c('p',[_c('em',[_vm._v("(delay: "+_vm._s(post.delay)+"ms)")])]),_vm._v(" "),_c('hr')],1)}),_vm._v(" "),(_vm.errors.length > 0)?_c('div',{staticClass:"errors"},[_c('h3',[_vm._v("Javascript Errors, if any:")]),_vm._v(" "),_c('ul',_vm._l((_vm.errors),function(error){return _c('li',[_vm._v("\n        "+_vm._s(error)+"\n      ")])}))]):_vm._e()],2)}
var Home_staticRenderFns = []
var Home_esExports = { render: Home_render, staticRenderFns: Home_staticRenderFns }
/* harmony default export */ var components_Home = (Home_esExports);
// CONCATENATED MODULE: ./src/components/Home.vue
function Home_injectStyle (ssrContext) {
  __webpack_require__("xgal")
}
var Home_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Home___vue_template_functional__ = false
/* styles */
var Home___vue_styles__ = Home_injectStyle
/* scopeId */
var Home___vue_scopeId__ = "data-v-286722ba"
/* moduleIdentifier (server only) */
var Home___vue_module_identifier__ = null
var Home_Component = Home_normalizeComponent(
  Home,
  components_Home,
  Home___vue_template_functional__,
  Home___vue_styles__,
  Home___vue_scopeId__,
  Home___vue_module_identifier__
)

/* harmony default export */ var src_components_Home = (Home_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Character.vue
//
//
//
//
//
//
//
//



/* harmony default export */ var Character = ({
  name: 'Character',
  metaInfo: function metaInfo() {
    return {
      title: this.title,
      meta: [{ vmid: 'description', name: 'description', content: this.description }]
    };
  },
  data: function data() {
    return {
      post: {
        title: '',
        data: ''
      },
      title: 'Character Bio',
      description: 'This is a character bio for the Reactive SEO experiment project ',
      delay: 300,
      errors: []
    };
  },
  created: function created() {
    var _this = this;

    this.post.title = this.$route.params.name;
    // console.log(service)
    axios_default.a.get('https://hcetest.getsandbox.com' + '/' + this.$route.params.name.toLowerCase()).then(function (response) {
      // JSON responses are automatically parsed.
      console.log(response.data);
      _this.post.data = response.data.status;
      _this.title = 'Character Bio for ' + _this.post.title;
      _this.description = 'This is the character Bio for ' + _this.post.title + ' - ' + _this.post.data.substr(0, 100) + '...';
      // console.log(this.posts)
    }).catch(function (e) {
      _this.errors.push(e);
    });

    // async / await version (created() becomes async created())
    //
    // try {
    //   const response = await axios.get(`http://jsonplaceholder.typicode.com/posts`)
    //   this.posts = response.data
    // } catch (e) {
    //   this.errors.push(e)
    // }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2699830a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Character.vue
var Character_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('p',[_vm._v("This is a character bio for character "+_vm._s(_vm.post.title)+":")]),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.post.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.post.data))])])}
var Character_staticRenderFns = []
var Character_esExports = { render: Character_render, staticRenderFns: Character_staticRenderFns }
/* harmony default export */ var components_Character = (Character_esExports);
// CONCATENATED MODULE: ./src/components/Character.vue
function Character_injectStyle (ssrContext) {
  __webpack_require__("eERE")
}
var Character_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Character___vue_template_functional__ = false
/* styles */
var Character___vue_styles__ = Character_injectStyle
/* scopeId */
var Character___vue_scopeId__ = "data-v-2699830a"
/* moduleIdentifier (server only) */
var Character___vue_module_identifier__ = null
var Character_Component = Character_normalizeComponent(
  Character,
  components_Character,
  Character___vue_template_functional__,
  Character___vue_styles__,
  Character___vue_scopeId__,
  Character___vue_module_identifier__
)

/* harmony default export */ var src_components_Character = (Character_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-meta/lib/vue-meta.js
var vue_meta = __webpack_require__("p3jY");
var vue_meta_default = /*#__PURE__*/__webpack_require__.n(vue_meta);

// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







console.log('Vue starting');

vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);
vue_esm["a" /* default */].use(vue_meta_default.a);

var router = new vue_router_esm["a" /* default */]({
  mode: 'history',
  base: window.location.pathname,
  routes: [{ path: '', component: src_components_Home }, { name: 'character', path: '/character/:name', component: src_components_Character }]
});

vue_esm["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  router: router,
  el: '#app',
  template: '<App/>',
  components: { App: src_App }
});

/***/ }),

/***/ "eERE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xgal":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.a05f8601306d93637a63.js